<template>
<div class="pin-book-controls">
    <div class="modal fade" id="my-pin-books" tabindex="-1" role="dialog" aria-labelledby="my-pin-books" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content text-start">
                <div class="modal-header border-0">
                    <h5 v-if="editor" class="modal-title">Edit Pin Book</h5>
                    <h5 v-else class="modal-title">Add To My Pin Books</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div v-if="deletingPinBook" class="modal-body">
                    <h2>Are you sure you want to erase this Pin Book?</h2>
                    <h4 class="text-muted">This can not be undone.</h4>
                </div>
                <div v-else class="modal-body">
                    <div class="row mb-3">
                        <template v-if="!editor">
                        <div class="col">
                            Pin Books are a great way to organize your pin collection and help others discover new pins.
                            To get started, click the New Pin Books button.
                        </div>
                        <div class="col-md-4 col-lg-3 text-end">
                            <a data-bs-toggle="collapse" href="#new-pin-book" class="btn btn-outline-primary" aria-expanded="false" aria-controls="collapseExample"><i class="fa-solid fa-plus"></i> New Pin Book</a>
                        </div>
                        </template>
                        <div class="col-12 mt-2" :class="{ collapse: !editor }" id="new-pin-book">
                            <div class="card card-body bg-light">
                                <div class="row mb-2 align-items-center">
                                    <div class="col-12 col-lg-10">
                                        <input type="text" id="newPinBookName" class="form-control" placeholder="Pin Book Title" v-model="newPinBookName">
                                    </div>

                                    <div class="col mt-2 mt-lg-0">
<!--                                        <template v-if="canPrivate">-->
                                        <div class="form-check form-switch float-start float-lg-none">
                                            <input type="checkbox" class="form-check-input" :disabled="!canPrivate" id="newPinBookPrivate" v-model="newPinBookPrivate">
                                            <label class="form-check-label text-warning" for="newPinBookPrivate">Private <i class="fa-solid fa-lock fa-xs"></i></label>
                                        </div>
                                        <div class="form-text d-inline d-lg-block ms-2 ms-lg-0 mt-lg-0">Make this book just for you.<span v-if="!this.user.sub && !this.enh"> (limit 2)</span></div>
<!--                                        </template>-->
                                    </div>
                                </div>
                                <div v-if="!editor" class="row">
                                    <div class="col text-end text-lg-start">
                                        <button @click="newPinBook" type="button" class="btn btn-primary text-light">Add To New Pin Book</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <template v-if="!editor">
                    <ul v-if="recentPinBooks.length && pinBooks.length > 10" class="list-group pin-book-list mb-4">
                        <h5>Recent Pin Books:</h5>
                        <a v-for="book in recentPinBooks" :key="book.id" @click.prevent="toggle(book)" href="#" class="list-group-item list-group-item-action">
                            <i v-if="book.isSelected" class="fa-solid fa-circle-check fa-lg text-primary me-1"></i>
                            <i v-else class="fa-regular fa-circle fa-lg text-secondary me-1"></i>
                            {{ book.name }}
                            <i v-if="book.is_private" class="ms-1 fa-solid fa-lock text-secondary"></i>
                        </a>
                    </ul>

                    <ul class="list-group pin-book-list">
                        <a v-for="book in pinBooks" :key="book.id" @click.prevent="toggle(book)" href="#" class="list-group-item list-group-item-action">
                            <i v-if="book.isSelected" class="fa-solid fa-circle-check fa-lg text-primary me-1"></i>
                            <i v-else class="fa-regular fa-circle fa-lg text-secondary me-1"></i>
                            {{ book.name }}
                            <i v-if="book.is_private" class="ms-1 fa-solid fa-lock text-secondary"></i>
                        </a>
                    </ul>
                    <small class="d-block text-muted mt-2">Missing Pin Books? <a @click.prevent="loadPinBooks" href="#">Reload Pin Books</a></small>
                    </template>
                </div>
                <div v-if="deletingPinBook" class="modal-footer justify-content-end">
                    <button @click="deletingPinBook=false" type="button" class="btn btn-outline-secondary me-3">don't erase it</button>
                    <button @click="erasePinBook" type="button" class="btn btn-danger"><i class="fa-solid fa-eraser"></i> Erase It!</button>
                </div>
                <div v-else-if="editor" class="modal-footer justify-content-between">
                    <button @click="deletingPinBook=true" type="button" class="btn btn-outline-danger"><i class="fa-solid fa-eraser"></i> Erase Pin Book</button>
                    <button @click="updatePinBook" type="button" class="btn btn-success text-light">Update</button>
                </div>
                <div v-else class="modal-footer justify-content-between">
                    <a href="/pin-books" class="btn btn-link text-secondary">View Pin Books</a>
                    <button type="button" class="btn btn-success text-light" data-bs-dismiss="modal">Done</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "PinBookControls",
    props: {
        pin: Object,
        user: Object,
        enh: {
            type: Boolean,
            default: false
        },
        editor: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            pinBooks: null,
            recentPinBooks: [],
            editPinBookId: null,
            editPrivateOriginal: false,
            newPinBookName: null,
            newPinBookPrivate: false,
            pinBooksLoaded: null,
            deletingPinBook: false
        }
    },
    mounted() {
        document.getElementById('my-pin-books').addEventListener('hide.bs.modal', (e) => {
            // console.log(e.relatedTarget.dataset.pin);
            this.editPinBookId = null;
            this.newPinBookName = null;
            this.newPinBookPrivate = false;
            this.deletingPinBook = false;
        });

        if (this.user.id) {
            if (localStorage.pinBooksLoaded && localStorage.pinBooks) {
                this.pinBooksLoaded = JSON.parse(localStorage.getItem('pinBooksLoaded'));
                if (this.diffLoaded(this.pinBooksLoaded.t) > 10 || this.pinBooksLoaded.u !== this.user.id) {
                    this.loadPinBooks();
                } else {
                    let pinBooks = JSON.parse(localStorage.getItem('pinBooks'));
                    this.pinBooks = pinBooks.sort((a, b) => (a.name > b.name) ? 1 : -1);

                    this.postLoad();
                }
            } else {
                this.loadPinBooks();
            }

            if (this.pinBooksLoaded && this.pinBooksLoaded.u !== this.user.id) {
                localStorage.removeItem('recentPinBooks');
            }
        }
    },
    created() {
        VueEvent.$on('loadEditAlbum', (album) => {
            this.editPinBookId = album.id;
            let pinBook = this.pinBooks.find(pb => pb.id === this.editPinBookId);
            this.newPinBookName = pinBook.name;
            this.newPinBookPrivate = pinBook.is_private;
            this.editPrivateOriginal = pinBook.is_private;
        });
    },
    computed: {
        canPrivate () {
            return (this.user.sub || this.enh) || (this.editor && this.editPrivateOriginal) || (this.pinBooks && this.pinBooks.filter(pb => pb.is_private).length < 2);
        }
    },
    methods: {

        postLoad () {
            // Loaded on PDV
            if (this.pin) {
                this.setMyPinBooks();
            }

            let recentPinBookIds = JSON.parse(localStorage.getItem('recentPinBooks'));
            if (recentPinBookIds && recentPinBookIds.length) {
                recentPinBookIds.forEach(id => {
                    let foundBook = this.pinBooks.find(pb => pb.id === id);
                    if (foundBook) {
                        this.recentPinBooks.push(foundBook);
                    }
                });
            }
        },

        loadPinBooks () {
            axios.get('/api/my/pin-books').then(response => {
                if (response.status === 200) {
                    let pinBooks = response.data.filter(b => {
                        b.isSelected = false;
                        return b;
                    }).sort((a, b) => (a.name > b.name) ? 1 : -1);

                    localStorage.setItem('pinBooks', JSON.stringify(pinBooks));
                    let now = new Date();
                    localStorage.setItem('pinBooksLoaded', JSON.stringify({'u': this.user.id, 't': now.getTime()}));
                    // localStorage.pinBooksLoaded = now.getTime();
                    this.pinBooks = pinBooks;

                    this.postLoad();
                }
            }).catch(error => {
                return false;
            });
        },

        setMyPinBooks () {
            axios.get('/api/my/pin-books', { params: { 'for-pin': this.pin.id } }).then(response => {
                if (response.status === 200) {
                    let selectedPinBooks = response.data.map(b => b.id);
                    this.pinBooks.forEach(b => {
                        b.isSelected = selectedPinBooks.includes(b.id);
                    });
                }
            });
        },

        updatePinBook () {
            if (this.newPinBookName) {
                axios.put('/pin-books/' + this.editPinBookId, {
                    name: this.newPinBookName,
                    is_private: this.newPinBookPrivate
                }).then(response => {
                    if (response.status === 200) {
                        let toEdit = this.pinBooks.findIndex(pb => pb.id === this.editPinBookId);
                        this.pinBooks[toEdit] = response.data;

                        let modal = bootstrap.Modal.getInstance(document.getElementById('my-pin-books'));
                        modal.hide();

                        this.storePinBooks();

                        this.$emit('updated', response.data);

                        // window.location.reload();
                    }
                });
            }
        },

        erasePinBook () {
            axios.delete('/pin-books/' + this.editPinBookId).then(response => {
                if (response.status === 200) {
                    let toEraseIndex = this.pinBooks.findIndex(pb => pb.id === this.editPinBookId);
                    this.pinBooks.splice(toEraseIndex, 1);

                    this.storePinBooks();

                    window.location.reload();
                }
            });
        },

        diffLoaded (dt) {
            let now = new Date();
            let diff = (now.getTime() - dt) / 1000;
            diff /= 60;
            return Math.abs(Math.round(diff));
        },

        toggle (book) {
            book.isSelected = !book.isSelected;
            axios.put('/my/pin-books/' + book.id + '/pin/' + this.pin.id, {
                album: book.id
            }).then(response => {
                if (response.status === 200) {
                    if (book.isSelected) {
                        this.recentPinBooks.unshift(book);
                        this.recentPinBooks = [...new Set(this.recentPinBooks)];
                        this.storeRecentPinBooks();
                    }
                }
            });
        },

        newPinBook () {
            if (this.newPinBookName) {
                axios.post('/pin-books', {
                    name: this.newPinBookName,
                    is_private: this.newPinBookPrivate,
                    pin_id: this.pin.id
                }).then(response => {
                    if (response.status === 200) {
                        let newBook = response.data;
                        newBook.isSelected = true;
                        this.pinBooks.unshift(newBook);
                        bootstrap.Collapse.getInstance(document.getElementById('new-pin-book')).hide();
                        this.newPinBookName = null;
                        this.newPinBookPrivate = false;

                        // localStorage.setItem('pinBooks', JSON.stringify(this.pinBooks));
                        this.storePinBooks();

                        this.recentPinBooks.unshift(newBook);
                        this.storeRecentPinBooks();
                    }
                });
            }
        },

        storePinBooks () {
            localStorage.setItem('pinBooks', JSON.stringify(this.pinBooks));
        },

        storeRecentPinBooks () {
            let recentPinBooks = this.recentPinBooks.map(pb => pb.id);
            localStorage.setItem('recentPinBooks', JSON.stringify(recentPinBooks));
        }

    },
    watch: {
        pin(newPin) {
            this.setMyPinBooks();
        }
    }
}
</script>
